module.exports = __webpack_public_path__ + "img/Vector_9.3d8e62d2.svg";